import { SCAN_PACK, formatMoneyIn } from '@alexiarest/shared';
import { useMe, useScanPackCheckout } from '../api/hooks';
import { useToast } from './Toast';

/**
 * «Comprar 150 escaneos · $5.00» (precios del 15 oct 2026): pago único, solo
 * para el mes en curso, no se renueva. Abre el pago de Stripe; los escaneos
 * los suma el webhook en cuanto se cobra. Sale en Tu plan y en el aviso de
 * escaneos al 80 % y al 100 %, solo si la cuenta ya paga un plan y solo al
 * dueño: la API (POST /billing/scan-pack) responde 403 a cualquier otro rol.
 */
export function ComprarEscaneos({
  moneda = 'EUR',
  variante = 'ghost',
}: {
  moneda?: 'EUR' | 'USD';
  variante?: 'ghost' | 'principal' | 'enlace';
}): JSX.Element | null {
  const comprar = useScanPackCheckout();
  const toast = useToast();
  const me = useMe();
  if (me.data?.user?.role !== 'owner') return null;
  const clase = variante === 'enlace' ? 'btn-enlace' : variante === 'principal' ? 'btn btn--sm' : 'btn btn--ghost btn--sm';
  return (
    <button
      type="button"
      className={`${clase} comprar-escaneos`}
      disabled={comprar.isPending}
      title="Solo para este mes. No se renueva."
      onClick={() =>
        comprar.mutate(undefined, {
          onSuccess: (d) => window.location.assign(d.url),
          onError: (e) => toast.fail(e),
        })
      }
    >
      {comprar.isPending ? 'Abriendo el pago…' : `Comprar ${SCAN_PACK.scans} escaneos · ${formatMoneyIn(SCAN_PACK.price, moneda)}`}
    </button>
  );
}
